import styled from "styled-components";
import { Modal, Button } from 'react-bootstrap';
import InputMask from "react-input-mask";

export const InputQt = styled.input`
border: none;
  ${({ aceitaDec }) => {
    if (aceitaDec) {
      return `
        width:140px;
        margin-left: 0px;
        border: 1px solid #999;
        border-radius: 4px;
      `
    } else {
      return "width:39px; border : none;margin-left: 5px;"
    }
  }} 
  height: 30px;
  text-align: center;
  padding: 5px;
  font-size: 16px;
  display: inline-block; 
  margin-top: -4px;
  outline : none;
`

export const InputCPF = styled(InputMask).attrs({
  placeholder: "DIGITE SEU CPF"
})`
  width: 60%;
  align-self: center;
  padding: 10px;
  font-size: 28px;
  color: #333;
  border: none;
  letter-spacing: 4px;
  text-align: center;
  outline: none;
  border-bottom: .4px solid rgba(0,0,0,.3);

  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: #999;
    font-size: 12px;
    letter-spacing: 1;
  }
`




export const CustomModal = styled(Modal).attrs({

})`
  .bodyModalCpf{
     display: flex;
     align-items: center;
     justify-content: center;
  }
`


export const ColumnContainer = styled.div`
  display: flex;
  flex-direction :column;
  & > span {
    margin-bottom: 10px
  }
`